import { createBrowserHistory } from 'history';

export const browserHistory = createBrowserHistory();

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export const toFormData = (obj) => {
  /**
   * this function take an object in and convert it to a formData
   * It is used in apiCall helper function
   */
  let fData = new FormData();

  for (let key in obj) {
    fData.append(key, obj[key]);
  }

  return fData;
};

let extraBackButtonControls = {};

export const handleBackButton = (customControlledData, customOnBackClick) => {
  window.onpopstate = () => {
    if (customControlledData) {
      customOnBackClick();
    } else if (
      extraBackButtonControls &&
      Object.keys(extraBackButtonControls).length
    ) {
      if (extraBackButtonControls.data) {
        extraBackButtonControls.func();
        document.body.style.overflowY = 'revert';
      }
    }
  };
};

/***
 * @param {Boolean} data
 * @param {Function} func
 */
export const addExtraBackButtonControls = ({ data, func }) => {
  extraBackButtonControls = { data, func };
};
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

/**
 * This function was  from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {number} rotation - optional rotation parameter
 */
export async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
  const image = await createImage(imageSrc);

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  image.width = image.width / 2;
  image.height = image.height / 2;

  const safeArea = Math.max(image.width, image.height) * 2;

  // set each dimensions to double largest dimension to allow for a safe area for the
  // image to rotate in without being clipped by canvas context
  canvas.width = safeArea;
  canvas.height = safeArea;

  if (!ctx) {
    return null;
  }

  // translate canvas context to a central location on image to allow rotating around the center.
  ctx.translate(safeArea / 2, safeArea / 2);
  ctx.rotate(getRadianAngle(rotation));
  ctx.translate(-safeArea / 2, -safeArea / 2);

  // draw rotated image and store data.
  ctx.drawImage(image, safeArea / 2 - image.width, safeArea / 2 - image.height);
  const data = ctx.getImageData(0, 0, safeArea, safeArea);

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // paste generated rotate image with correct offsets for x,y crop values.
  ctx.putImageData(
    data,
    0 - safeArea / 2 + image.width - pixelCrop.x,
    0 - safeArea / 2 + image.height - pixelCrop.y
  );
  return canvas.toDataURL('image/jpeg');
}

export function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

/***
 * checks whether <checked> is within today
 * @param {Date} checked
 * @returns {boolean}
 */
export function checkDateToday(checked) {
  const now = new Date();
  return now.toDateString() === checked.toDateString();
}

/***
 * persian/arabic-indic digits to latin, e.g. for tel: links
 * @param {String} value
 * @returns {String}
 */
export const toLatinDigits = (value) =>
  String(value).replace(/[۰-۹٠-٩]/g, (d) => String(d.charCodeAt(0) & 0xf));
